import type { TGetCandidateChallenges } from "@api";
import type { ObjectId } from "@bbj-types/utils";
import { useCallback } from "react";
import { axiosChallenges } from "./axios";
import type { ICreateCandidateChallengeBody } from "./postCandidateChallenges";

export const useUpsertCandidateChallenges = () => {
  const [state, execute, cancel] = axiosChallenges<TGetCandidateChallenges, ICreateCandidateChallengeBody>(
    {
      method: "PUT",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (candidateId: ObjectId, data: ICreateCandidateChallengeBody) => {
      return execute({
        url: `/candidate/${candidateId}/upsert`,
        data,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
